
import React from 'react';
import { Shield, Check, Lock, Home } from 'lucide-react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { useNavigate } from 'react-router-dom';

const WhyTrustUs = () => {
  const navigate = useNavigate();

  const trustPillars = [
    {
      title: "Servicio Gratuito",
      description: "Nuestros servicios esenciales no tienen costo para que todos puedan acceder a orientación.",
      icon: <Check className="h-8 w-8 text-teal" />
    },
    {
      title: "Información Actualizada",
      description: "Basada en fuentes oficiales y revisada regularmente.",
      icon: <Shield className="h-8 w-8 text-teal" />
    },
    {
      title: "Privacidad Garantizada",
      description: "Tus datos están protegidos y nunca se comparten con terceros.",
      icon: <Lock className="h-8 w-8 text-teal" />
    }
  ];

  return (
    <div className="min-h-screen bg-cream font-sans">
      <Navigation />
      
      <div className="container mx-auto px-4 py-12 md:py-16">
        {/* Inicio Button */}
        <div className="max-w-3xl mx-auto mb-8">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="flex items-center gap-2 text-gray-600 hover:text-[#2563EB] border-gray-300 hover:border-[#2563EB] hover:bg-blue-50 transition-all font-medium"
          >
            <Home className="h-4 w-4" />
            Inicio
          </Button>
        </div>

        {/* Section 1: Intro Block */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h1 className="text-2xl md:text-3xl font-semibold text-navy mb-6">
            ¿Por Qué Confiar en Migrante Amigo?
          </h1>
          <p className="text-base md:text-lg text-coolGray leading-relaxed max-w-2xl mx-auto">
            En Migrante Amigo nos comprometemos a brindar orientación confiable y segura a la comunidad inmigrante. Entendemos los desafíos que enfrentas porque muchos de nosotros hemos estado en tu lugar.
          </p>
        </div>

        {/* Section 2: Nuestros Pilares de Confianza */}
        <div className="max-w-4xl mx-auto mb-20">
          <h2 className="text-xl md:text-2xl font-semibold text-navy text-center mb-12">
            Nuestros Pilares de Confianza
          </h2>
          
          <div className="space-y-6">
            {trustPillars.map((pillar, index) => (
              <Card 
                key={index}
                className="bg-slate-50 hover:bg-slate-100/50 transition-all duration-300 hover:shadow-lg hover:scale-[1.02] border border-gray-100 shadow-md"
              >
                <CardContent className="p-5 md:p-6">
                  <div className="flex flex-col md:flex-row items-center md:items-start gap-4 md:gap-6">
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 bg-teal/10 rounded-xl flex items-center justify-center shadow-sm border border-teal/20">
                        {pillar.icon}
                      </div>
                    </div>
                    <div className="text-center md:text-left flex-1">
                      <h3 className="text-lg md:text-xl font-semibold text-navy mb-3">
                        {pillar.title}
                      </h3>
                      <p className="text-coolGray text-base leading-relaxed">
                        {pillar.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Section 3: Final CTA */}
        <div className="max-w-3xl mx-auto">
          <Card className="bg-gradient-to-br from-blue-50 to-blue-100/50 border border-blue-200/50 shadow-xl">
            <CardContent className="p-8 md:p-12 text-center">
              <h2 className="text-xl md:text-2xl font-semibold text-navy mb-4">
                ¿Listo para dar el siguiente paso?
              </h2>
              <p className="text-coolGray text-base md:text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
                Tu privacidad está protegida. La orientación es clara. Empieza gratis.
              </p>
              <button 
                className="bg-teal hover:bg-teal-hover text-white px-12 py-4 rounded-xl text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 min-h-[56px]"
                onClick={() => window.location.href = '/login'}
              >
                Comienza Ahora – Es Gratis
              </button>
            </CardContent>
          </Card>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default WhyTrustUs;
